// src/pages/EventsPage.tsx

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';

export function EventsPage() {
  const { year } = useParams<{ year: string }>();
  const navigate = useNavigate();
  const events = useAppStore((s) => s.events);
  const isLoading = useAppStore((s) => s.isLoading);
  const error = useAppStore((s) => s.error);
  const fetchEvents = useAppStore((s) => s.fetchEvents);

  useEffect(() => {
    if (year) {
      fetchEvents(year);
    }
  }, [year, fetchEvents]);

  if (isLoading) {
    return (
      <div className="events-page" role="status" aria-label="Loading events">
        <div className="loading-indicator">Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="events-page">
        <div className="error-state" role="alert">
          <p>{error}</p>
          <button
            className="retry-button"
            onClick={() => year && fetchEvents(year)}
            style={{ minHeight: '44px' }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="events-page">
        <div className="events-header">
          <button
            className="back-button"
            onClick={() => navigate('/years')}
            aria-label="Back to years"
            style={{ minHeight: '44px' }}
          >
            ← Back
          </button>
          <h1>{year} Events</h1>
        </div>
        <p className="empty-state">No accessible events</p>
      </div>
    );
  }

  return (
    <div className="events-page">
      <div className="events-header">
        <button
          className="back-button"
          onClick={() => navigate('/years')}
          aria-label="Back to years"
          style={{ minHeight: '44px' }}
        >
          ← Back
        </button>
        <h1>{year} Events</h1>
        <button
          className="refresh-button"
          onClick={() => year && fetchEvents(year)}
          aria-label="Refresh events"
          style={{ minHeight: '44px' }}
        >
          Refresh
        </button>
      </div>
      <ul className="events-list" role="list">
        {events.map((event) => (
          <li key={event.name}>
            <button
              className="event-card"
              onClick={() => navigate(`/years/${year}/${event.name}`)}
              aria-label={`${event.name}, ${event.photoCount} photos`}
              style={{ minHeight: '44px', width: '100%' }}
            >
              <span className="event-name">📷 {event.name}</span>
              <span className="event-photo-count">
                — {event.photoCount} {event.photoCount === 1 ? 'photo' : 'photos'}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
